import { createStyles } from '@material-ui/core';
import {
  spacing,
} from '#web-components/styles';

const styles = () => createStyles({
  root: {
    height: spacing * 5,
    width: spacing * 5,
    padding: 0,
  },
});

export default styles;
